/**
 * RESPONSIBILITY: draw the other events sharing a tag with this one.
 *
 * A tag and not a hand-picked list: picked once, it keeps finding events added months
 * later, and a hand-picked list is a list somebody has to remember to come back to.
 *
 * The event being read is excluded — a page that recommends itself is a page that has
 * wasted one of its three slots.
 */
import { idOf } from '@framework/core';
import { THEME } from '@app/sections';
import { Band } from './Band';
import { EventCard } from '../EventCard';
import { isVisible, byNext } from '../../commons/when';
import type { BandProps } from './kind';

export function Related({ s, all, event }: BandProps) {
  const here = idOf(event);
  const shown = all
    .filter((e) => idOf(e) !== here && isVisible(e) && (!s.tag || e.categories?.includes(s.tag)))
    .sort(byNext)
    .slice(0, s.count || 3);

  if (!shown.length) return null;

  return (
    <Band theme={THEME.Related} heading={s.heading || 'Also on'}>
      <div className="ev-related">
        {shown.map((e) => <EventCard key={idOf(e)} e={e} />)}
      </div>
    </Band>
  );
}
